import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CommonConstants } from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  HttpRequestMethods,
  handleError
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Observable } from 'rxjs';
import { AEMContent } from '../../models';
import { EndpointKeys, IDP_APPS } from '../../models/sky-club.constants';
@Injectable({
  providedIn: 'root'
})
export class ContentService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  getContent = (): Observable<AEMContent> =>
    new ApiBuilder<undefined, AEMContent>(this.http, this.appConfig)
      .app(IDP_APPS.SKYCLUB)
      .endpointKey(EndpointKeys['SKYCLUB_AEM_URL'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(IDP_APPS.SKYCLUB)
      .create();
}
